import React from "react";
import { AppBar, Box, Button, Grid, Toolbar, Typography } from "@mui/material";

import { styled } from "@mui/system";
import { Link } from "react-router-dom";

const ClearLink = styled(Link)({
  color: "black",
  textDecoration: "none",
  textTransform: "none",
});

const GlassGrid = styled(Grid)({
  paddingLeft: "5%",
  paddingRight: "5%",
  backgroundColor: "rgba(255, 255, 255, 0.3)",
  backgroundImage: `linear-gradient(to bottom right, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0))`,
  backdropFilter: `blur(20px)`,
  boxShadow: "10px 10px 10px rgba(30, 30, 30, 0.1)",
});

const AppBarStyle = styled(AppBar)(({ theme }) => ({
  backgroundColor: "rgba(255, 255, 255, 0.3)",
  backgroundImage: `linear-gradient(to bottom right, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0))`,
  backdropFilter: `blur(20px)`,
  boxShadow: "10px 10px 10px rgba(30, 30, 30, 0.1)",
  backgroundSize: "100vw 100%",
  paddingLeft: "3%",
  paddingRight: "3%",
  [theme.breakpoints.down("sm")]: {
    paddingLeft: "0",
    paddingRight: "0",
  },
}));

const ButtonGrid = styled(Grid)({
  maxWidth: "100%",
});

const RoundButton = styled(Button)(({ theme }) => ({
  marginLeft: "1vw",
  borderRadius: "90px",
  boxShadow: "none",
}));

export default function HeaderGuest() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBarStyle position="static">
        <Toolbar>
          <ClearLink to="/">
            <Box
              component="img"
              src={`${process.env.PUBLIC_URL}/images/LogoIndomobilCareer.png`}
              alt="IndomobilCareerLogo"
              sx={{
                width: "auto",
                height: "8vh",
                paddingTop: "2px",
                paddingBottom: "2px",
              }}
            />
          </ClearLink>
          <Typography sx={{ flexGrow: 1 }} />
          <ButtonGrid container justifyContent="flex-end" alignItems="center">
            <ClearLink to="/Login">
              <Button color="inherit">Login</Button>
            </ClearLink>
            <ClearLink to="/Register">
              <RoundButton variant="contained" color="primary">
                Register
              </RoundButton>
            </ClearLink>
          </ButtonGrid>
        </Toolbar>
      </AppBarStyle>
    </Box>
  );
}
